const TOKEN_PLACEHOLDER = "[redacted]";
const TOKEN_QUERY_KEYS = new Set(["token", "access-grant"]);
const TOKEN_KEY_PATTERN = /(token|authorization|grant)/i;
const PUBLIC_TOKEN_PATHS = [
  /(\/public\/itinerary-review\/)[^/?#]+/gi,
  /(\/public\/itinerary-reviews\/)[^/?#]+/gi,
  /(\/public\/pdfs\/)[^/?#]+/gi,
];

export function scrubPostHogEvent(event) {
  if (!event || typeof event !== "object") return event;

  return {
    ...event,
    properties: scrubPostHogValue(event.properties),
  };
}

export function sanitizePostHogUrl(value) {
  if (typeof value !== "string" || !value) return value;

  const withRedactedPaths = PUBLIC_TOKEN_PATHS.reduce(
    (current, pattern) => current.replace(pattern, `$1${TOKEN_PLACEHOLDER}`),
    value
  );

  try {
    const isAbsolute = /^[a-z][a-z0-9+.-]*:/i.test(withRedactedPaths);
    const startsLikePath = withRedactedPaths.startsWith("/");
    if (!isAbsolute && !startsLikePath && !withRedactedPaths.includes("?")) {
      return redactLooseTokenParams(withRedactedPaths);
    }

    const url = new URL(withRedactedPaths, "https://emanta.invalid");
    for (const key of TOKEN_QUERY_KEYS) {
      if (url.searchParams.has(key)) {
        url.searchParams.set(key, TOKEN_PLACEHOLDER);
      }
    }

    if (url.hash.length > 1) {
      const hashParams = new URLSearchParams(url.hash.slice(1));
      let hashChanged = false;
      for (const key of TOKEN_QUERY_KEYS) {
        if (hashParams.has(key)) {
          hashParams.set(key, TOKEN_PLACEHOLDER);
          hashChanged = true;
        }
      }
      if (hashChanged) url.hash = hashParams.toString();
    }

    if (isAbsolute) return url.toString();
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return redactLooseTokenParams(withRedactedPaths);
  }
}

function scrubPostHogValue(value, key = "") {
  if (value === null || value === undefined) return value;

  if (key.toLowerCase() === "credential" || TOKEN_KEY_PATTERN.test(key)) {
    return typeof value === "string" ? TOKEN_PLACEHOLDER : value;
  }

  if (typeof value === "string") {
    return sanitizePostHogUrl(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => scrubPostHogValue(item));
  }

  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([childKey, childValue]) => [
        childKey,
        scrubPostHogValue(childValue, childKey),
      ])
    );
  }

  return value;
}

function redactLooseTokenParams(value) {
  return value
    .replace(/([?&]token=)[^&#]+/gi, `$1${TOKEN_PLACEHOLDER}`)
    .replace(/([?&#]access-grant=)[^&#]+/gi, `$1${TOKEN_PLACEHOLDER}`);
}
